/**
 * Studio FTUX constants shared across the stack. These live in `src/constants`
 * (rather than a frontend feature module) because the Express session
 * middleware imports them server-side; keeping them free of browser-only
 * dependencies means importing here can never break server startup.
 *
 * A Studio "test as a client" preview magic link carries `studioClientPreview=true`
 * as its post-login destination param. The session middleware reads it to skip the
 * single-use confirmation interstitial for these freshly minted preview links.
 */
export const STUDIO_CLIENT_PREVIEW_PARAM = 'studioClientPreview';
export const STUDIO_CLIENT_PREVIEW_VALUE = 'true';

/**
 * The CRM page stamps this `window.name` on the Internal Portal tab before it
 * opens a "test as a client" preview tab. From the preview, the client-portal
 * "Return to CRM" button re-targets this name with `window.open('', name)` to
 * switch the browser back to that existing Internal Portal tab — `opener.focus()`
 * is blocked by browsers as focus-stealing, but targeting an existing named tab
 * on a user click is honored.
 */
export const STUDIO_INTERNAL_PORTAL_TAB_NAME = 'assemblyInternalPortal';
